// Gestão de Frota (módulo "frota", pedido 2026-10-01) — painel com
// gráficos, veículos, motoristas, custos e manutenção, tudo real
// (backend src/fleet-management + relatórios do rastreamento). Quem vê:
// admin sempre; funcionário/cliente frotista com a permissão "Gestão de
// Frota". Cliente só enxerga a própria frota (o backend força isso); a
// equipe escolhe de qual cliente quer ver no seletor do topo.
import { createFileRoute } from "@tanstack/react-router";
import { FleetPageGate } from "@/components/fleet-management-page";

export const Route = createFileRoute("/frota")({
  head: () => ({ meta: [{ title: "Gestão de Frota" }] }),
  component: () => <FleetPageGate />,
});
